import { Tarea } from './tarea.model';
import { EventEmitter, Type, TemplateRef } from '@angular/core';
import { find, merge } from 'lodash';
import { GlobalInfo } from './global.model';
import { TramiteBase } from './tramite.model';

export type RenderFormIn = 'modal' | 'view';
export type TypeTaskEvent = 'finish' | 'closeForm' | 'updateTask' | 'refreshFlow' | 'startSecondary' | 'finishAutoSave';

/**
 * Mapa de configuraciones para cada formulario
 * del aplicativo.
 *
 * @export
 * @interface FormMapConfig
 */
export interface FormMapConfig {
  [key: string]: {
    [key: string]: FormConfig<any>;
  };
}

/**
 * Configuración del formulario para una tarea.
 *
 * @export
 * @interface FormConfig
 * @template T
 */
export interface FormConfig<T> {
  component: Type<T>;
  config: {
    renderIn: RenderFormIn;
  };
}

/**
 * Contexto por defecto que poseen los
 * formularios dinámicos.
 *
 * @export
 * @interface Context
 */
export interface Context {
  task: Tarea;
  typeProcess: string;
  headerFlow?: TemplateRef<any>;
}

/**
 * Tipo de evento que puede tratar el
 * generador de los componentes dinámicos.
 *
 * @export
 * @interface TaskEvent
 */
export interface TaskEvent {
  type: TypeTaskEvent;
  params?: Partial<{
    skip: boolean;
  }>;
  data?: any;
}

/**
 * Informacion para iniciar una secundaria
 *
 * @export
 * @interface DataIniciarSecundaria
 */
export interface DataIniciarSecundaria {
  id: number;
  tarea_id: number;
}

/**
 * Contexto por defecto
 * que poseen las tareas para ejecutar el auto guardado
 *
 * @export
 * @interface ContextAutoSave
 * @extends {Context}
 */
export interface ContextAutoSave extends Context {
  idTaskOrigin: number;
  messageLoad: string;
}

/**
 * Clase base para crear un formulario dinámico.
 *
 * @export
 * @abstract
 * @class DynamicComponentForm
 */
export abstract class DynamicComponentForm {
  // Contexto del formulario
  ctx: any;
  // Manejador de eventos
  event: EventEmitter<TaskEvent>;

  /**
   * Cerrar el formulario.
   *
   * @memberof NoneFormComponent
   */
  close() {
    const e: TaskEvent = {
      type: 'closeForm'
    };
    this.event.emit(e);
  }
  /**
   * Actualiza la informacion de la tarea
   *
   * @param {Tarea} task
   * @memberof DynamicComponentForm
   */
  updateTask(task: Tarea) {
    const e: TaskEvent = {
      type: 'updateTask',
      data: task
    };
    this.event.emit(e);
  }

  /**
   * Actualiza la informacion basica de la tarea actual renderizada
   *
   * @param {Tarea} task
   * @param {Partial<Tarea>} data
   * @memberof DynamicComponentForm
   */
  taskUpdateInfoBasicTask(task: Tarea, data: Partial<Tarea>) {
    let newTask = task;
    if (data && typeof data === 'object' && Object.keys(data).length) {
      newTask = merge(task, data);
    }
    this.updateTask(newTask);
  }

  /**
   * Refrescar el flujo actual
   *
   * @memberof DynamicComponentForm
   */
  refreshFlow() {
    const e: TaskEvent = {
      type: 'refreshFlow',
    };
    this.event.emit(e);
  }

  /**
   * realiza el cierre de la tarea y refresca el flujo para
   *
   * @memberof DynamicComponentForm
   */
  startSecondary(data: DataIniciarSecundaria) {
    const e: TaskEvent = {
      type: 'startSecondary',
      data: data
    };
    this.event.emit(e);
  }
  /**
   * Consultar tarea siguiente a la actual.
   *
   * @memberof DynamicComponentForm
   */
  getNextTask(global: Partial<GlobalInfo>, currentTask: Tarea): Tarea | null {
    let nextTask: Tarea = null;
    const currentActivity: any = find(global.flow.actividades, {
      id: currentTask.meta.idActivity
    });
    if (currentActivity) {
      nextTask = currentActivity.tareas[currentTask.meta.index + 1];
    }
    return nextTask;
  }

  /**
   * Retorna el tramite al que pertenece la tarea actual
   *
   * @param {Partial<GlobalInfo>} global
   * @returns {TramiteBase}
   * @memberof DynamicComponentForm
   */
  getTramite(global: Partial<GlobalInfo>): TramiteBase {
    let tramite: TramiteBase;
    if (global.flow) {
      tramite = {
        id: global.flow.id,
        nombre: global.title,
        descripcion: global.flow.descripcion
      };
    }
    return tramite;
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/models/forms.model.ts